import { render } from "./Auction.vue?vue&type=template&id=0b3e256e"
import script from "./Auction.vue?vue&type=script&lang=js"
export * from "./Auction.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__